import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import type { Routes } from '@angular/router';
import { RouterModule } from '@angular/router';
import { DatastoreTrackingConsentModeModule } from '@freelancer/datastore/collections';
import { FeatureFlagsModule } from '@freelancer/feature-flags';
import { FileDownloadAlertModule } from '@freelancer/file-download';
import { FreelancerAsyncPipeModule } from '@freelancer/pipes';
import { TrackingModule } from '@freelancer/tracking';
import { FooterModule } from 'app/footer/footer.module';
import { GiveGetFooterModule } from 'app/give-get-footer/give-get-footer.module';
import { NavigationLoggedOutModule } from 'app/navigation/navigation-logged-out/navigation-logged-out.module';
import { NavigationLoggedOutHomeModule } from 'app/navigation/navigation-logged-out-home/navigation-logged-out-home.module';
import { SeoNavbarModule } from 'app/navigation/seo-navbar/seo-navbar.module';
import { ToastAlertsModule } from 'app/toast-alerts/toast-alerts.module';
import { TrackingConsentBannerComponent } from 'app/tracking-consent-banner/tracking-consent-banner.component';
import { LoggedOutShellComponent } from './logged-out-shell.component';

const routes: Routes = [
  {
    path: '',
    component: LoggedOutShellComponent,
    data: {
      lightStatusBar: true,
    },
    loadChildren: () =>
      import('app/app-routing.module').then(m => m.AppRoutingModule),
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    DatastoreTrackingConsentModeModule,
    FileDownloadAlertModule,
    FooterModule,
    FreelancerAsyncPipeModule,
    GiveGetFooterModule,
    NavigationLoggedOutModule,
    NavigationLoggedOutHomeModule,
    SeoNavbarModule,
    ToastAlertsModule,
    FeatureFlagsModule,
    TrackingModule,
    TrackingConsentBannerComponent,
  ],
  declarations: [LoggedOutShellComponent],
  exports: [RouterModule],
})
export class LoggedOutRoutingModule {}
